import { LANGUAGE, RATING } from "../constants/constant";
import Happy from "../assets/image/emoji-happy.png";
import Neutral from "../assets/image/emoji-neutral.png";
import NotHappy from "../assets/image/emoji-not-happy.png";
import Unhappy from "../assets/image/emoji-unhappy.png";
import VeryHappy from "../assets/image/emoji-very-happy.png";
import { properties } from "./Properties";

export const getCurrentTime = () => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
};

export const getCurrentDateTime = () => {
  const date = new Date().toISOString().split("T");
  return date[0] + " " + date[1].split(".")[0];
};

export const getLanguage = () => {
  if (LANGUAGE.EN_US === properties.languageId) {
    return LANGUAGE.ENGLISH;
  } else {
    return LANGUAGE.ARABIC;
  }
};

export const setSessionStorage = (key, value) => {
  window.sessionStorage.setItem(key, value);
};

export const getSessionStorage = (key) => {
  return window.sessionStorage.getItem(key);
};

export const removeSessionStorage = (key) => {
  window.sessionStorage.removeItem(key);
};

export const getQuestionOptions = (t) => {
  return [
    {
      index: 1,
      text: t("very_happy"),
      image: `${VeryHappy}`,
      alt: t("very_happy"),
      value: RATING.VERY_HAPPY,
    },
    {
      index: 2,
      text: t("happy"),
      image: `${Happy}`,
      alt: t("happy"),
      value: RATING.HAPPY,
    },
    {
      index: 3,
      text: t("neutral"),
      image: `${Neutral}`,
      alt: t("neutral"),
      value: RATING.NEUTRAL,
    },
    {
      index: 4,
      text: t("unhappy"),
      image: `${Unhappy}`,
      alt: t("unhappy"),
      value: RATING.UNHAPPY,
    },
    {
      index: 5,
      text: t("not_happy_at_all"),
      image: `${NotHappy}`,
      alt: t("not_happy_at_all"),
      value: RATING.NOT_HAPPY,
    },
  ];
};